import dispatcher from "../dispatcher";
import { expenditureCatagoryConstant } from "../constants/constants";
import rq from "../components/utility/rq.js";

export function createExCatagory(exCat) {
    rq.postJson("/api/v1/expCategory", exCat).then((data) => {
        exCat.exCatId = data[0].lastId;
        dispatcher.dispatch({ type: expenditureCatagoryConstant.EXPENDITURECATAGORY_CREATED, exCat });
    }).catch((err) => {
        dispatcher.dispatch({ type: expenditureCatagoryConstant.EXPENDITURECATAGORY_CREATION_FAILED, msg: `creating  ${exCat.exCatName} failed !` });
    });
}

export function fetchAllExCat() {
    rq.getJsonData("/api/v1/expCategory").then((data) => {
        //console.log("inside exCat Action fetch all >>>>>>>>>>>>rq");
        dispatcher.dispatch({ type: expenditureCatagoryConstant.FETCHED_ALL_EXPENDITURECATAGORY, data });
    }).catch(() => {
        dispatcher.dispatch({ type: expenditureCatagoryConstant.EXPENDITURECATAGORY_FETCH_FAILED, msg: "Fetching shift failed ! " });
    });
}



// WEBPACK FOOTER //
// ./src/jsx/actions/expenditure-catagory-action.jsx